import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
import { putEntities } from '../entities/actions';
import { deviationSchema } from '../normalizr/schemas/deviation';
import { normalize } from 'normalizr';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
import { createWithDeviation, createWithDeviationAndText } from '../../DaEditorWrapper/utils';
export const fetchDeviation = createAction(`${actionTypePrefix}.FETCH_DEVIATION`, (payload)=>payload);
export const editDeviation = createAction(`${actionTypePrefix}.EDIT_DEVIATION`, (payload)=>payload);
export const editDeviationSuccess = createAction(`${actionTypePrefix}.EDIT_DEVIATION_SUCCESS`, (payload)=>payload);
export const deleteDeviation = createAction(`${actionTypePrefix}.DELETE_DEVIATION`, (payload)=>payload);
export const deleteDeviationSuccess = createAction(`${actionTypePrefix}.DELETE_DEVIATION_SUCCESS`, (payload)=>payload);
export const updateDeviationEntity = (deviation)=>{
    const { entities  } = normalize(deviation, deviationSchema);
    return putEntities({
        entities
    });
};
export const updateNormalizedDeviationEntity = (normalizedDeviation)=>putEntities({
        entities: {
            [deviationSchema.key]: {
                [normalizedDeviation.entityId]: normalizedDeviation
            }
        }
    });
export const shareDeviationToPost = (deviation)=>pushModal(ModalType.STATUS_UPDATE, {
        wrapInModal: false,
        params: {
            initialState: createWithDeviation(deviation)
        }
    });
export const shareDeviationAndTextToPost = (deviation, text)=>pushModal(ModalType.STATUS_UPDATE, {
        wrapInModal: false,
        params: {
            initialState: createWithDeviationAndText(deviation, text)
        }
    });
